import { useEffect } from "react";
import { Redirect, useParams } from "react-router-dom";

import styled from "styled-components/macro";

import { useNewSignupCreationFlow } from "Signups/SignupView/NewSignup";
import { useSignups } from "Signups/state.js";
import { useIsSignupEditMode } from "Signups/stateHooks";

import { useIsSignupClosed } from "../../SharedComponents/useIsSignupClosed";
import getIsSignupEligibleForFundIt from "../../utils/getIsSignupEligibleForFundIt";
import SignupHeader from "../SignupHeader/SignupHeader";

import "./SignupSheet.scss";
import SignupSheetFooter from "./SignupSheetFooter";

export default function SignupSheet() {
  const [state] = useSignups();
  const { signupListID, signupTab } = useParams();
  const signupIsLoaded = Boolean(state?.currentSignupList?.ID);
  const isSignupEligibleForFundIt = getIsSignupEligibleForFundIt(
    state?.currentSignupList?.signupListTypeID
  );

  const { cancelCreationFlow } = useNewSignupCreationFlow();

  const { isArchived } = useIsSignupClosed();
  const { setIsSignupEditMode } = useIsSignupEditMode();

  useEffect(() => {
    if (signupTab && signupTab !== "items") {
      cancelCreationFlow();
      setIsSignupEditMode(true);
    }
  }, [signupTab, cancelCreationFlow, setIsSignupEditMode]);
  if (
    (signupTab &&
      signupIsLoaded &&
      signupTab === "fund-it" &&
      !isSignupEligibleForFundIt) ||
    (!signupTab && signupIsLoaded)
  ) {
    return <Redirect to={`/signups/${signupListID}/items`} />;
  }

  if (!state.currentSignupList?.signupItems) return null;

  return (
    <OuterWrapper>
      <SignupHeader />
      {!isArchived && <SignupSheetFooter />}
    </OuterWrapper>
  );
}

const OuterWrapper = styled.div`
  flex: 1;
  flex-grow: 1;
  flex-shrink: 1;
  width: 100%;
  box-sizing: border-box;
  min-height: 100vh;
  max-height: 100vh;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;

  a {
    text-decoration: none;
  }
  a:hover {
    text-decoration: none;
  }

`;
